import california from './ca.png';
import florida from './fl.png'

const LOCATIONS = [
    {
        name: 'California',
        country: 'United States of America',
        img: california,
        alt: 'Picture of California',
        linkto: 'california'
    },
    {
        name: 'Florida',
        country: 'United States of America',
        img: florida,
        alt: 'Picutre of Florida',
        linkto: 'florida',
    }
]

export default LOCATIONS;